import EditHardware from './EditHardware.vue';
export default EditHardware;
